import { Icon } from '@joor/design-system'
import AliceCarousel from 'react-alice-carousel'
import type { Props as AliceCarouselProps } from 'react-alice-carousel'
import styled from 'styled-components'

const StyledButton = styled.div`
  border-radius: 40px;
  border: 1px solid var(--color-primary-100);
  background: var(--color-neutral-100);
  opacity: 40%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    opacity: 100%;
    cursor: pointer;
  }
`
const StyledDot = styled.div`
  height: 8px;
  width: 8px;
  cursor: pointer;
`

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
  height: 336px;
  &.small-container {
    height: 236px;
  }
  .alice-carousel,
  .alice-carousel__wrapper {
    height: 100% !important;
  }
  .alice-carousel__dots {
    position: relative;
    top: -60px;
  }
  .alice-carousel__next-btn,
  .alice-carousel__prev-btn {
    position: absolute;
    width: 60px;
    height: 100%;
    top: 0;
    display: flex !important;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
  }
  .alice-carousel__next-btn {
    right: 0;
  }
  .alice-carousel__dots-item {
    background-color: white !important;
    margin: 0 4px !important;
    border-radius: 50% !important;
  }
  .alice-carousel__dots-item.__active {
    background-color: var(--color-secondary-600) !important;
  }
`

export const Carousel = ({
  items,
  props,
  isSmallContainer = false,
}: {
  items: JSX.Element[]
  props?: AliceCarouselProps
  isSmallContainer?: boolean
}) => {
  const defaultProps = {
    mouseTracking: true,
    items: items,
    controlsStrategy: 'alternate',
    disableButtonsControls: items.length <= 1,
    disableDotsControls: items.length <= 1,
    ...(items.length > 1 && {
      autoPlay: true,
      animationDuration: 500,
      autoPlayInterval: 7000,
      infinite: true,
    }),
    renderNextButton: () => (
      <StyledButton>
        <Icon iconName="chevron-right" />
      </StyledButton>
    ),
    renderPrevButton: () => (
      <StyledButton>
        <Icon iconName="chevron-left" />
      </StyledButton>
    ),
    renderDotsItem: () => <StyledDot />,
  }

  return (
    <StyledContainer className={isSmallContainer ? 'small-container' : ''}>
      <AliceCarousel {...defaultProps} {...props} />
    </StyledContainer>
  )
}
